import { Badge, Flex, OverlayTrigger, Popover } from '@wyz/ui';

const DISPLAYED_BADGES_LIMIT = 5;

function BadgeGroup({ elements }: { elements: string[] }) {
  return (
    <Flex className='gap-1' wrap='wrap'>
      {elements.slice(0, DISPLAYED_BADGES_LIMIT).map((element, index) => (
        <Badge pill bg='light-gray' key={index}>
          {element}
        </Badge>
      ))}
      {elements.length > DISPLAYED_BADGES_LIMIT && (
        <OverlayTrigger
          trigger={['focus', 'hover']}
          placement='bottom'
          overlay={
            <Popover className='py-1 px-2'>
              <Flex className='gap-1' wrap='wrap'>
                {elements.map((element, index) => (
                  <Badge pill bg='light-gray' key={index}>
                    {element}
                  </Badge>
                ))}
              </Flex>
            </Popover>
          }
        >
          <Badge pill bg='light-gray'>
            {'+'}
            {elements.length - DISPLAYED_BADGES_LIMIT}
          </Badge>
        </OverlayTrigger>
      )}
    </Flex>
  );
}

export default BadgeGroup;
